import React from "react";
import { connect } from "react-redux";
import DetailComponent from "../components/PortfolioDetailComponent";
import LetsWork from "../components/LetsWorkTogether";
import { useTranslation } from "lib/i18n";
import Seo from "components/Seo";

const PortfolioDetail = (props) => {
  const { language } = useTranslation();
  const isFrench = language === "fr";
  const item = props.item;
  const fallbackTitle = isFrench ? "Projet" : "Project";
  const title = item ? item.title : fallbackTitle;
  const description = item
    ? item.desc
    : (isFrench
        ? "Détails du projet Quivio."
        : "Quivio project details.");
  const path = `/works/${props.match.params.id}`;

  return (
    <>
      <Seo
        title={title}
        description={description}
        path={path}
        noIndex={!item}
      />
      <DetailComponent item={props.item} />
      <LetsWork />
    </>
  );
};

const mapStateToProps = (state, props) => {
  // display the work detail who match with clicked image by checking id
  const item = state.works.find((item) => item.id === +props.match.params.id);

  return { item };
};

export default connect(mapStateToProps, null)(PortfolioDetail);
